import PropTypes from 'prop-types'
import React from 'react'
import { SectionHeader } from '../../../../../components/generic'
import StockListItem from './StockListItem'

const StockSection = (props) => {
  const { medications, title, residentId, icon } = props

  if (!medications || !medications.length) return null

  return (
    <div style={styles.container}>
      <SectionHeader greyLine isSubSection title={title} />
      {medications.map((medication) => (
        <StockListItem
          key={medication.id}
          icon={icon}
          medication={medication}
          residentId={residentId}
        />
      ))}
    </div>
  )
}

StockSection.propTypes = {
  medication: PropTypes.object
}

const styles = {
  container: {
    margin: '20px 0px 30px'
  }
}

export default StockSection
